import { linkAssemblers } from "@/lib/unified-dtos/unified-media-mapper/helpers";
import { LadyMinV2DTOPhotoSrcs } from "@/models/lady-dtos/LadyMinV2DTO";

export function createPhotoSrcs(
  mediaNameParam: string | null | undefined,
  safe: "safe",
): LadyMinV2DTOPhotoSrcs;

export function createPhotoSrcs(
  mediaNameParam: string | null | undefined,
  safe?: undefined,
): LadyMinV2DTOPhotoSrcs | undefined;

export function createPhotoSrcs(
  mediaNameParam: string | null | undefined,
  safe?: "safe" | undefined,
) {
  const mediaName = mediaNameParam || undefined;

  if (!mediaName) {
    return {
      small: linkAssemblers.safeMakePhotoThumbnailSmall({ mediaName }),
      medium: linkAssemblers.safeMakePhotoThumbnailMedium({ mediaName }),
      large: linkAssemblers.safeMakePhotoUrl({ mediaName }),
    };
  }

  if (safe === "safe" && !mediaName) {
    return {
      small: linkAssemblers.safeMakePhotoThumbnailSmall({ mediaName }),
      medium: linkAssemblers.safeMakePhotoThumbnailMedium({ mediaName }),
      large: linkAssemblers.safeMakePhotoUrl({ mediaName }),
    };
  }

  return {
    small: linkAssemblers.makePhotoThumbnailSmall({ mediaName }),
    medium: linkAssemblers.makePhotoThumbnailMedium({ mediaName }),
    large: linkAssemblers.makePhotoUrl({ mediaName }),
  };
}
